<template>
  <div class="operative-layout">
    <AwlHeader />
    <!-- <SideDrawer /> -->
    <router-view class="page" />
    <ConfirmBox />
  </div>
</template>

<script>

export default {
  components: {
    AwlHeader: () => import('./Header.vue'),
    ConfirmBox: () => import(/* webpackChunkName: "component-confirm-modal" */ './ConfirmBox.vue'),
  },
};

</script>

<style lang="scss">

.operative-layout {
  .page {
    flex-grow: 1;
    padding-top: 60px;
    position: relative;

    &--v-center {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

</style>
